import {
	PropsWithChildren,
	ReactElement,
	ReactNode
} from "react";
import { isNotNil } from "client/Misc/utils";
import { getReactNodeKey, flattenChildren } from "client/Misc/reactUtils";
import styles from "./AnalyticsTabLayout.module.less";

export const AnalyticsTabLayout = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.root}>
			{children}
		</div>
	);
};
AnalyticsTabLayout.displayName = "AnalyticsTabLayout";

const ToolbarContainer = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.toolbarContainer}>
			{children}
		</div>
	);
};
ToolbarContainer.displayName = "AnalyticsTabLayout.ToolbarContainer";

type AnalyticsTabLayoutSection = {
	title?: string;
};

const Section = (props: PropsWithChildren<AnalyticsTabLayoutSection>): ReactElement => {
	const {
		title,
		children
	} = props;

	return (
		<section className={styles.section}>
			{isNotNil(title) && (
				<h3 className={styles.sectionTitle}>{title}</h3>
			)}
			{children}
		</section>
	);
};
Section.displayName = "AnalyticsTabLayout.Section";

const CardList = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	const childrenArray: ReactNode[] = flattenChildren(children);

	return (
		<ul className={styles.cardList}>
			{childrenArray.map((c, i) => (
				<li key={getReactNodeKey(c, i)}>
					{c}
				</li>
			))}
		</ul>
	);
};
CardList.displayName = "AnalyticsTabLayout.CardList";

AnalyticsTabLayout.ToolbarContainer = ToolbarContainer;
AnalyticsTabLayout.Section = Section;
AnalyticsTabLayout.CardList = CardList;